"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._modifyAdjustment = exports._getStockAdjustment = exports._getSimulationStock = void 0;
const axios_1 = __importDefault(require("axios"));
const error_response_1 = require("utils/error-response");
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const _getSimulationStock = ({ year, month, }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/transaction/stock';
    const config = {
        params: { month, year },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError,
            data: [],
            errorCode,
            errorMessage,
        };
    }
});
exports._getSimulationStock = _getSimulationStock;
const _getStockAdjustment = ({ day, id_header, }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/transaction/stock-adjustment';
    const config = {
        params: { day, id_header },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError,
            data: { day: 0, total: 0 },
            errorCode,
            errorMessage,
        };
    }
});
exports._getStockAdjustment = _getStockAdjustment;
const _modifyAdjustment = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/transaction/stock-adjustment';
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    // const params = new URLSearchParams();
    // params.append("id_header", String(arg.id_header));
    // params.append("total", String(arg.total));
    // params.append("day", String(arg.day));
    try {
        const { data } = yield axios_1.default.put(url, arg, config);
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: data.errorCode,
            data: data.data
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: response.isError, errorMessage: response.errorMessage, message: 'Modify Unsuccessfull', data: {
                id: ''
            } });
    }
});
exports._modifyAdjustment = _modifyAdjustment;
